const grupo = {
    venda: ['B2B', 'B2B_APP', 'CALLCENTER', 'FORCA_VENDAS'],
    vendedores:  ['CALLCENTER', 'FORCA_VENDAS'],
    vendedores_sac:  ['CALLCENTER', 'FORCA_VENDAS', 'SAC'],
    b2b: ['B2B', 'B2B_APP'],
    sac: ['SAC'],
    fv: ['FORCA_VENDAS'],
    call: ['CALLCENTER'],
};

const menus = [
  // Para buscar ícones, consultar em : https://coreui.io/icons/all/
  {
    menu: "Cadastros",
    href: "/cadastros",
    children: [
      // {
      //   modulo: "ADMIN_DOMINIO",
      //   href: "/cadastros/api-gateway",
      //   icon: "cil-vector",
      // },
      {
        modulo: "ADMIN_COLABORADOR",
        href: "/cadastros/colaboradores",
        icon: "cil-user",
      },
      {
        modulo: "ADMIN_LICENCA",
        href: "/cadastros/contratos-e-licencas",
        icon: "cil-lock-unlocked",
      },
      {
        modulo: "ADMIN_FILIAL",
        href: "/cadastros/filiais",
        icon: "cil-building",
      },
      {
        modulo: "ADMIN_CLIENTE",
        href: "/cadastros/clientes",
        icon: "cil-group",
      },
      {
        modulo: "ADMIN_COMO_CONHECEU",
        href: "/cadastros/como-conheceu",
        icon: "cil-magnifying-glass",
      },
      {
        modulo: "ADMIN_CONTA_CORRENTE",
        href: "/cadastros/conta-corrente",
        icon: "cil-money",
        sistemas: grupo.vendedores,
      },
      {
        modulo: "ADMIN_COMISSAO",
        href: "/cadastros/comissao",
        icon: "cil-money",
        sistemas: grupo.vendedores,
      },
      {
        modulo: "ADMIN_TINTOMETRICO",
        href: "/cadastros/tintometrico",
        icon: "cil-paint",
        sistemas: grupo.vendedores,
        // @TODO VALIDAR POR MÓDULO
      },
      {
        modulo: "ADMIN_EXPEDIENTE",
        href: "/expediente/expediente",
        icon: "cil-calendar-check",
        sistemas: grupo.vendedores_sac,
      },
      {
        modulo: "ADMIN_FAQ",
        href: "/cadastros/faq",
        icon: "cil-notes",
      },
      {
        modulo: "ADMIN_MODULO",
        href: "/cadastros/modulos",
        icon: "cil-sitemap",
      },
      {
        modulo: "ADMIN_PERFIL",
        href: "/cadastros/perfis",
        icon: "cil-address-book",
      },
      {
        modulo: "ADMIN_PRODUTO",
        href: "/cadastros/produtos",
        icon: "cil-basket",
      },
      /*    {
        modulo: "ADMIN_PRECIFICACAO_CLIENTE_FINAL",
        href: "/cadastros/precificacao-cliente-final",
        icon: "cil-calculator",
      }, */
      {
        modulo: "ADMIN_SAC",
        href: "/cadastros/sac",
        icon: "cil-comment-bubble",
        sistemas: grupo.sac,
      },
      {
        modulo: "ADMIN_SETOR_ATENDIMENTO",
        href: "/cadastros/setores",
        icon: "cil-room",
      },
      {
        modulo: "ADMIN_AGENDA",
        href: "/cadastros/agendas",
        icon: "cil-calendar",
        sistemas: grupo.vendedores,
      },
      {
        modulo: "ADMIN_TAGS_FILTRO",
        href: "/cadastros/tag-filtro",
        icon: "cil-tags",
        sistemas: grupo.vendedores,
      },
      {
        modulo: "ADMIN_RESTRICAO_VENDA",
        href: "/cadastros/restricoes-venda",
        icon: "cil-ban",
      },
      {
        modulo: "ADMIN_PRECO_NEGOCIADO_MOTIVO",
        href: "/cadastros/preco-negociado-motivo",
        icon: "cil-dollar",
        sistemas: grupo.vendedores,
      },
      {
        modulo: "ADMIN_CONCORRENTE",
        href: "/cadastros/concorrentes",
        icon: "cil-building",
        sistemas: grupo.vendedores,
      },
      {
        modulo: "ADMIN_TIPO_CONTATO",
        href: "/cadastros/tipo-contato",
        icon: "cil-contact",
        sistemas: grupo.vendedores,
      },
    ],
  },
  {
    menu: "Campanhas Comerciais",
    href: "/campanhas",
    children: [
      {
        modulo: "ADMIN_CAMPANHA",
        href: "/campanhas/comerciais",
        icon: "cil-briefcase",
        sistemas: grupo.venda,
      },
      {
        modulo: "ADMIN_CUPOM",
        href: "/campanhas/cupons",
        icon: "cil-tag",
        sistemas: grupo.venda,
      },
      {
        modulo: "ADMIN_DESCONTO",
        href: "/campanhas/descontos",
        icon: "cil-dollar",
        sistemas: grupo.venda,
      },
      {
        modulo: "ADMIN_PRECO_PROMOCIONAL",
        href: "/campanhas/precos-promocionais",
        icon: "cil-bullhorn",
        sistemas: grupo.venda,
      },
    ],
  },
  {
    menu: "Campanhas de Metas",
    href: "/campanhas/metas",
    children: [
      {
        modulo: "ADMIN_CAMPANHA",
        href: "/campanhas/metas",
        icon: "cil-chart-line",
        sistemas: grupo.call,
      },
    ],
  },
  {
    menu: "Marketing",
    children: [
      {
        modulo: "ADMIN_BANNERS",
        href: "/marketing/banners",
        icon: "cil-image-plus",
      },
      {
        modulo: "ADMIN_VITRINE",
        href: "/marketing/vitrines",
        icon: "cil-library",
      },
      {
        modulo: "ADMIN_LINKS_INTEGRADOS",
        href: "/marketing/links-integrados",
        icon: "cil-link",
      },
      {
        modulo: "ADMIN_GALERIA_IMAGENS",
        href: "/marketing/galerias-imagens",
        icon: "cil-image-plus",
      },
      {
        modulo: "ADMIN_CANAL_ATENDIMENTO",
        href: "/marketing/canais-atendimento",
        icon: "cil-chat-bubble",
        sistemas: grupo.b2b,
      },
      {
        modulo: "ADMIN_CATALOGO",
        href: "/marketing/catalogos",
        icon: "cil-book",
        sistemas: grupo.b2b,
      },
      {
        modulo: "ADMIN_DEPARTAMENTO",
        href: "/marketing/departamentos",
        icon: "cil-list-rich",
        sistemas: grupo.b2b,
      },
      {
        modulo: "ADMIN_LINK",
        href: "/marketing/links",
        icon: "cil-link",
        sistemas: grupo.b2b,
      },
      {
        modulo: "ADMIN_CONTEUDO_VISUAL",
        href: "/marketing/conteudos-visuais",
        icon: "cil-image-plus",
        sistemas: grupo.b2b,
      },
      {
        modulo: "ADMIN_LOGOS",
        href: "/marketing/logos",
        icon: "cil-image-plus",
      },
      {
        modulo: "ADMIN_MARCA",
        href: "/marketing/marcas",
        icon: "cil-badge",
        sistemas: grupo.b2b,
      },
      {
        modulo: "ADMIN_MERSHANDISING",
        href: "/marketing/mershandising",
        icon: "cil-money",
        sistemas: grupo.fv,
      },
      {
        modulo: "ADMIN_SOCIAL",
        href: "/marketing/sociais",
        icon: "cil-thumb-up",
        sistemas: grupo.b2b,
      },
      {
        modulo: "ADMIN_PAGINA",
        href: "/marketing/paginas",
        icon: "cil-library",
        sistemas: grupo.b2b,
      },
      {
        modulo: "ADMIN_FORMULARIOS",
        href: "/marketing/formularios",
        icon: "cil-list",
        sistemas: grupo.b2b,
      },
      {
        modulo: "ADMIN_FORMULARIOS_PESQUISA",
        href: "/marketing/formularios-pesquisa",
        icon: "cil-magnifying-glass",
        sistemas: grupo.fv,
      },
      {
        modulo: "ADMIN_POSTAGEM",
        href: "/marketing/postagens",
        icon: "cil-newspaper",
        sistemas: grupo.b2b,
      },
      {
        modulo: "ADMIN_PAGINA_TERMOS",
        href: "/marketing/pagina-termos",
        icon: "cil-comment-square",
        sistemas: grupo.b2b,
      },
      {
        modulo: "ADMIN_TRABALHE_CONOSCO",
        href: "/marketing/trabalhe-conosco",
        icon: "cil-briefcase",
        sistemas: grupo.b2b,
      },
      {
        modulo: "ADMIN_SECAO_RODAPE",
        href: "/marketing/secoes-rodape",
        icon: "cil-list-low-priority",
        sistemas: grupo.b2b,
      },
    ],
  },
  {
    menu: "Regra de Negócio",
    href: "/regra-negocio",
    children: [
      {
        modulo: "ADMIN_REGRA_NEGOCIO",
        href: "/regra-negocio/regra",
        icon: "cil-money",
        sistemas: grupo.venda,
      },
      {
        modulo: "ADMIN_SINALEIRA_LUCRATIVIDADE",
        href: "/regra-negocio/sinaleira-lucratividade",
        icon: "cil-speedometer",
        sistemas: grupo.venda,
      },
    ],
  },
  {
    menu: "Entrega",
    href: "/entrega",
    children: [
      {
        modulo: "ADMIN_ENTREGA",
        href: "/entrega/condicao-entrega",
        icon: "cil-truck",
      },
      {
        modulo: "ADMIN_TRANSPORTE",
        href: "/entrega/transporte",
        icon: "cil-truck",
      },
    ],
  },
  {
    menu: "Pagamento",
    href: "/pagamento",
    children: [
      {
        modulo: "ADMIN_PAGAMENTO",
        href: "/pagamento/pagamento",
        icon: "cil-money",
        sistemas: grupo.venda,
      },
      {
        modulo: "ADMIN_CONDICAO_PAGAMENTO",
        href: "/pagamento/condicao-pagamento",
        icon: "cil-money",
        sistemas: grupo.venda,
      },
    ],
  },
  {
    menu: "Pedidos",
    href: "/pedidos",
    children: [
      {
        modulo: "ADMIN_PEDIDO_INTEGRACAO",
        href: "/pedidos/pedidos-pendentes-integracao",
        icon: "cil-clock",
        sistemas: grupo.venda,
      },
      {
        modulo: "ADMIN_PEDIDO",
        href: "/pedidos/orcamentos-e-pedidos",
        icon: "cil-file",
        sistemas: grupo.venda,
      },
      {
        modulo: "ADMIN_PEDIDO_TIMELINE",
        href: "/pedidos/pedidos-timeline",
        icon: "cil-playlist-add",
        sistemas: grupo.venda,
      },
      {
        modulo: "ADMIN_SUGESTAO_COMPRA",
        href: "/pedidos/sugestoes-compra",
        icon: "cil-cart",
        sistemas: grupo.vendedores,
      },
      {
        modulo: "ADMIN_PEDIDO_PRIORIDADE",
        href: "/pedidos/pedido-prioridade",
        icon: "cil-star",
        sistemas: grupo.venda,
      },
    ],
  },
  {
    menu: "Notificações",
    href: "/notificacoes",
    children: [
      {
        modulo: "ADMIN_NOTIFICACAO",
        href: "/notificacoes/notificacoes",
        icon: "cil-bullhorn",
        sistemas: grupo.venda,
      },
    ],
  },
  {
    menu: "Configurações",
    href: "/configuracoes",
    children: [
      {
        modulo: "ADMIN_CONFIGURACAO",
        href: "/configuracoes/configuracoes",
        icon: "cil-cog",
      },
      {
        modulo: "ADMIN_PARAMETRO",
        href: "/configuracoes/parametros",
        icon: "cil-list-numbered",
      },
      {
        modulo: "ADMIN_DASHBOARD",
        href: "/configuracoes/dashboards",
        icon: "cil-bar-chart",
      },
      {
        modulo: "ADMIN_RELATORIO",
        href: "/configuracoes/relatorios",
        icon: "cil-chart-line",
      },
      // {
      //   modulo: "ADMIN_ACOMPANHAMENTO_CLIENTE",
      //   href: "/configuracoes/funis-acompanhamento",
      //   icon: "cil-columns",
      // },
      {
        modulo: "ADMIN_VIEW_TEMPLATE",
        href: "/configuracoes/views-templates",
        icon: "cil-file",
      },
      {
        modulo: "ADMIN_CONFIGURACAO_IA",
        href: "/configuracoes/configuracao-ia",
        icon: "cil-star",
        sistemas: grupo.vendedores,
      },
      {
        modulo: "ADMIN_CAMPOS_INTEGRACAO",
        href: "/configuracoes/campos-integracao",
        icon: "cil-swap-horizontal",
      },
      {
        modulo: "ADMIN_CAMPOS_ADICIONAIS",
        href: "/configuracoes/campos-adicionais",
        icon: "cil-swap-horizontal",
      },
      {
        modulo: "ADMIN_SQL_ERP_INTEGRACAO",
        href: "/configuracoes/sql-erp-integracao",
        icon: "cil-code",
      },
      {
        modulo: "ADMIN_CARGA_DADOS",
        href: "/configuracoes/cargas",
        icon: "cil-cloud-download",
      },
      {
        modulo: "ADMIN_LOG",
        href: "/configuracoes/logs",
        icon: "cil-history",
      },
      {
        modulo: "ADMIN_WEBHOOK",
        href: "/configuracoes/webhooks",
        icon: "cil-code",
      },
      {
        modulo: "ADMIN_FORMULA_CALCULO",
        href: "/configuracoes/formulas-calculo",
        icon: "cil-calculator",
        sistemas: grupo.venda,
      },
    ],
  },
];

export const NOMES_SISTEMAS = {
    'SAC': 'VersoSAC',
    'B2B': 'VersoCommerce',
    'B2B_APP': 'VersoCommerce App',
    'CALLCENTER': 'VersoCall',
    'FORCA_VENDAS': 'VersoVendas',
    'CHAT': 'VersoChat',
};

export function getSistemasParaRota(path) {
    for (const menu of menus) {
        for (const item of (menu.children || [])) {
            if (item.href === path && item.sistemas && item.sistemas.length > 0) {
                return item.sistemas;
            }
        }
    }
    return null;
}

export default menus;
